/**
 * Coleções da loja (`StoreCollection`, docs/store-themes.md etapa 3): um conjunto de
 * produtos com endereço próprio (`/collection/<slug>`) e SEO, que a seção "Vitrine de
 * produtos" também pode mostrar. O backend resolve os produtos; o editor e a vitrine
 * usam estas listas para os rótulos.
 */
export const STORE_COLLECTION_KINDS = [
    { value: 'MANUAL', label: 'Escolha manual', help: 'Você escolhe os produtos e a ordem.' },
    { value: 'CATEGORY', label: 'Por categoria', help: 'Os produtos das categorias escolhidas.' },
    {
        value: 'ON_SALE',
        label: 'Em promoção',
        help: 'Produtos com preço promocional vigente ou numa promoção ativa da loja.',
    },
    { value: 'NEWEST', label: 'Novidades', help: 'Os produtos mais recentes da loja.' },
    {
        value: 'BEST_SELLING',
        label: 'Mais vendidos',
        help: 'Os que mais saíram nos pedidos pagos da loja nos últimos 90 dias.',
    },
];
/** Ordem dos produtos nas regras que deixam escolher (CATEGORY e ON_SALE). */
export const STORE_COLLECTION_SORTS = [
    { value: 'newest', label: 'Mais recentes' },
    { value: 'price_asc', label: 'Menor preço' },
    { value: 'price_desc', label: 'Maior preço' },
    { value: 'name', label: 'Nome (A-Z)' },
];
/** Regras em que a ordem é escolhida pelo lojista. */
export function storeCollectionHasSort(kind) {
    return kind === 'CATEGORY' || kind === 'ON_SALE';
}
/**
 * Teto de produtos das regras que não têm fim natural (Novidades, Mais vendidos): sem
 * ele, "Novidades" seria a loja inteira em outra ordem.
 */
export const STORE_COLLECTION_RULE_LIMIT = 48;
/** Janela das vendas que contam para "Mais vendidos". */
export const STORE_COLLECTION_BEST_SELLING_DAYS = 90;
/** Produtos numa coleção manual. */
export const STORE_COLLECTION_MAX_PRODUCTS = 200;
//# sourceMappingURL=collections.js.map